import { Button as ButtonComponent, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const SalaryConnectWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`

export const IllustrationWrapper = styled.figure`
  display: flex;
  justify-content: center;
  margin-bottom: ${Spacing.S40};
`

export const Illustration = styled.img`
  width: 262px;
  height: 207px;
`

export const ContentWrapper = styled.section`
  max-width: 652px;
  margin-bottom: ${Spacing.S32};
`

export const TitleWrapper = styled.header`
  margin-bottom: ${Spacing.S16};
`

export const Footer = styled.footer`
  display: flex;
  justify-content: center;
`
export const Button = styled(ButtonComponent)`
  width: 300px;
  text-align: center;
`
